import { connect } from 'react-redux';
import compose from 'recompose/compose';
import withState from 'recompose/withState';
import withHandlers from 'recompose/withHandlers';
import { t } from '../../../../../modules/infra/i18n';

import { sharedEnhancer } from '../Shared';
import { appointmentsImport, deleteImportedAppointments } from '../../actions';
import confirmModal from '../../../../common/confirmModal';

const mapDispatchToProps = {
  import: appointmentsImport,
  deleteImportedAppointments,
};

const enhance = compose(
  connect(null, mapDispatchToProps),
  sharedEnhancer,
  withState('importResults', 'setImportResults', false),
  withHandlers({
    onChange: props => (e) => {
      props.setImportResults(false);
      props.onChange(e);
    },
    deleteAppointments: props => async () => {
      const confirmed = await confirmModal({
        type: 'danger',
        title: t('admin:import.appointments.delete_unpaid.modal_title'),
        message: t('admin:import.appointments.delete_unpaid.modal_message'),
      });

      if (!confirmed) {
        return false;
      }

      return props.deleteImportedAppointments(props.params.id).then(response => props.addNotification({
        level: 'success',
        message: t('admin:import.appointments.delete_success', { count: response.deleted }),
        autoDismiss: 20,
        title: t('admin:import.appointments.success_title'),
      }));
    },
    onSubmit: props => (e) => {
      props.onSubmit(e).then((result) => {
        const messages = [
          t('admin:import.appointments.results.imported', { count: result.addedCount }),
          t('admin:import.appointments.results.barber_not_found', { count: result.barberNotFoundCount }),
          t('admin:import.appointments.results.blocked_time_no_service', { count: result.blockedTimeNoServiceCount }),
          t('admin:import.appointments.results.overlapping', { count: result.overlappingCount }),
        ];

        props.setImportResults(messages);
      });
    },
  })
);

export default enhance;
